import React from "react";

export default function FloatingAppWidget() {
  return (
    <>
      <div className="floating-app-widget">
        <div className="app-widget-card">
          {/* GOOGLE PLAY ICON */}
          <div className="app-widget-icon">
            <img
              src="/Playstore.png"
              alt="Google Play"
            />
          </div>

          {/* TEXT + BUTTON STACK */}
          <div className="app-widget-content">
            <div className="app-widget-title">Google Play</div>

            <a
              href="https://play.google.com/store/apps/details?id=com.stadopayroll.app"
              target="_blank"
              rel="noopener noreferrer"
              className="app-widget-btn"
            >
              Get App
            </a>
          </div>
        </div>
      </div>

      {/* ================= STYLES ================= */}
      <style>{`
        /* ===============================
           FLOATING WRAPPER
        ================================ */
        .floating-app-widget{
          position:fixed;
          bottom:26px;
          left:26px;
          z-index:9999;
          animation:widgetFloat 4s ease-in-out infinite;
        }

        @keyframes widgetFloat{
          0%,100%{ transform:translateY(0); }
          50%{ transform:translateY(-10px); }
        }

        /* ===============================
           GLASS CARD
        ================================ */
        .app-widget-card{
          display:flex;
          align-items:center;
          gap:14px;
          padding:14px 18px;

          background-color:#2b2b2b;
          opacity:0.9;

          background-image:linear-gradient(
            180deg,
            rgba(45,45,45,0.95),
            rgba(25,25,25,0.85)
          );

          backdrop-filter:blur(18px);
          -webkit-backdrop-filter:blur(18px);

          border-radius:18px;
          border:1px solid rgba(255,255,255,0.18);

          box-shadow:
            0 20px 45px rgba(0,0,0,0.45),
            inset 0 1px 0 rgba(255,255,255,0.08);

          font-family: Inter, system-ui, sans-serif;
        }

        /* ===============================
           ICON
        ================================ */
        .app-widget-icon img{
          width:26px;
          height:26px;
          display:block;
        }

        /* ===============================
           CONTENT STACK
        ================================ */
        .app-widget-content{
          display:flex;
          flex-direction:column;
          gap:6px;
        }

        .app-widget-title{
          font-size:14px;
          font-weight:600;
          color:#fff;
          letter-spacing:0.2px;
        }

        .app-widget-btn{
          align-self:flex-start;
          padding:6px 14px;
          font-size:12px;
          font-weight:600;
          text-decoration:none;
          color:#000;
          background:#fff;
          border-radius:10px;
          transition:all .3s ease;
        }

        .app-widget-btn:hover{
          transform:translateY(-2px);
          box-shadow:0 8px 20px rgba(0,0,0,0.4);
        }

        /* ===============================
           MOBILE
        ================================ */
        @media(max-width:600px){
          .floating-app-widget{
            bottom:18px;
            left:18px;
          }
        }
                        /* ===============================
                MOBILE - HIDE WIDGET
              ================================ */
              @media (max-width: 600px){
                .floating-app-widget{
                  display: none !important;
                }
              }

      `}</style>
    </>
  );
}
